import { Divider, Grid, Typography } from "@mui/material";
import { BtnAdd, BtnBack, BtnDuplicate, BtnSave } from "components/Button/ButtonAll";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import SwitchFormItem from "components/Input/Switch";
import { TextAreaItem } from "components/Input/TextArea";
import { TextBoxItem } from "components/Input/TextBox";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import { IHolidaySubmit } from "../Indicator/IIndicatorInterface";
import { GetMenuPermission } from "utilities/SystemFunction";

const HolidayManagementForm = () => {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const [loadingTable, setLoadingTable] = useState(false);
    const [dMinYear, setMinYear] = useState() as any;
    const [dMaxYear, setMaxYear] = useState() as any;
    const [isDateDup, setDateDup] = useState(false);
    const [isEdit, setEdit] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sID",
        sSortDirection: "asc"
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const getFormInitial = () => {
        AxiosFn.Post(`HolidayManagement/GetInitialHoliday`, {}, (result) => { });
    }

    const getTable = (p: PaginationInterface, nMode?) => {
        setLoadingTable(true);

        if (sID != null) {
            setEdit(true)
        }

        let param = {
            ...p,
            sHolidayYearID: sID,
            nMode: nMode,
            nPageSize: 5000
        }

        AxiosFn.Post(`HolidayManagement/GetTableHolidayForm`, param, (result) => {
            form.setValue("dYearPickerHoliday", result.objResult?.objHoliday.sYear);
            form.setValue("statusHoliday", result.objResult?.objHoliday.isActive);

            //set max and min date of year
            let dYear = result.objResult?.objHoliday.sYear;
            let dMin = new Date(moment(dYear).year(), 0, 1);
            setMinYear(dMin);
            let dMax = new Date(moment(dYear).year(), 11, 31);
            setMaxYear(dMax);
            setDataRow({
                ...p,
                arrRows: result.lstHolidayManagementForm,
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });

            //set default value
            let arrResult = [];
            arrResult = result.lstHolidayManagementForm;

            arrResult.forEach(f => {
                form.setValue(`sHolidayName_${f.sID}`, f.sHolidayName);
                form.setValue(`sDescription_${f.sID}`, f.sDescription);
                form.setValue(`dDatePicker_${f.sID}`, moment(f.nDate));
            });

            setLoadingTable(false);
        });
    };

    const handleDelete = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            let arrClone = dataRow;
            let result = arrClone.arrRows.filter((f) => !e.includes(f.sID));
            arrClone.arrRows = arrClone.arrRows.filter((f) => e.includes(f.sID));

            if (arrClone.arrRows.length > 0) {
                arrClone.arrRows.forEach((f) => {
                    f.isDeleteDraft = true
                });
            }
            setDataRow({
                ...arrClone,
                arrRows: [...result.filter(f => !f.isDeleteDraft)],
                nDataLength: result.filter(f => !f.isDeleteDraft).length,
            });

            // onClearForm();
            DialogFn.Success("ลบสำเร็จ", () => {
            });
        });
    }

    const handleAddItem = () => {
        setLoadingTable(true);
        let arrResult = dataRow;
        let arrNewItem = [];

        //set max and min date of year
        let dYear = form.getValues("dYearPickerHoliday");
        let dMin = new Date(moment(dYear).year(), 0, 1);
        setMinYear(dMin);
        let dMax = new Date(moment(dYear).year(), 11, 31);
        setMaxYear(dMax);

        if (dYear === "") {
            DialogFn.Warning("กรุณาระบุปฏิทินประจำปี")
        } else {
            let arrID = arrResult.arrRows.length > 0 ? arrResult.arrRows.map((m) => m.sID) : [];
            let nID = (arrID.length > 0 ? Math.max(...arrID) : 0) + 1;

            arrNewItem.push(...arrResult.arrRows);

            let objNewItem = {
                sID: nID + "",
                nID: nID,
                nNo: nID,
                nDate: form.setValue(`dDatePicker_${nID.toString()}`, !Number.isNaN(dYear) ? dMin : null),
                sHolidayName: null,
                sDescription: null,
                isActive: true,
                isDelete: false,
            }
            arrNewItem.push(objNewItem);

            arrResult.arrRows = [...arrNewItem];
        }
        setLoadingTable(false);
    }

    const handleDuplicateDate = (e, id) => {
        setDateDup(false);
        let sConvertDate = new Date(e._d.getFullYear(), e._d.getMonth(), e._d.getDate());
        let sDate = sConvertDate.toLocaleDateString();
        let oldData = dataRow.arrRows;
        oldData.forEach(f => {
            let dDate = form.getValues(`dDatePicker_${f.sID}`);
            let sConvertDate = new Date(moment(dDate._d).year(), moment(dDate._d).month(), moment(dDate._d).date());
            let sFormDate = sConvertDate.toLocaleDateString();
            if (f.nID !== id && sFormDate === sDate) {
                setDateDup(true);
                DialogFn.Warning("มีรายการวันหยุดที่ซ้ำกันในระบบ");
            }
        });
    };

    const handleSubmit = (e, nMode) => {
        // nMode:
        // 1 = save
        // 2 = duplicate
        // setDupMode(nMode);
        let array = [];
        let isDup = false;
        array = dataRow.arrRows;

        array.forEach(f => {
            let arrDataRow = {} as IHolidaySubmit;

            arrDataRow.sID = f.sID;
            f.nID = +(f.sID);
            f.nDate = moment(e[`dDatePicker_${f.sID}`]).valueOf() || moment(f.dDate).valueOf();
            f.sHolidayName = e[`sHolidayName_${f.sID}`] || f.sHolidayName;
            f.sDescription = e[`sDescription_${f.sID}`] || f.sDescription;
        });

        for (let i = 0; i < array.length; i++) {
            for (let j = 1; j < array.length; j++) {
                if (array[i].nDate === array[j].nDate && array[i].nID !== array[j].nID) {
                    isDup = true
                }
            }
        }

        if (isDateDup || isDup) {
            DialogFn.Warning("มีรายการวันหยุดที่ซ้ำกันในระบบ");
        } else {
            let param = {
                nYear: moment(form.getValues("dYearPickerHoliday")).valueOf(),
                isActive: e["statusHoliday"],
                lstHolidayManagement: array,
                sLocation: location.pathname,
                nMode: nMode
            }

            DialogFn.Submit("คุณต้องการบันทึกข้อมูลใช่หรือไม่ ?", () => {
                AxiosFn.Post(`HolidayManagement/OnSubmit`, param, (result) => {
                    if (result.nStatusCode === 200) {
                        DialogFn.Success("บันทึกสำเร็จ", () => {
                            if (nMode === 2) {
                                getTable(dataRow, nMode);
                            } else {
                                navigate("/HolidayManagement")
                            }
                        });
                    }
                }, (err) => {
                    if (err.nStatusCode === 409) {
                        DialogFn.Warning(err.Message);
                    } else if (!err.response) {
                        DialogFn.Warning(err.Message);
                    }
                });
            });
        }
    }

    const handleYear = (e) => {
        //check year avilable
        let param = {
            nChooseDate: form.getValues("dYearPickerHoliday").valueOf()
        }

        AxiosFn.Post(`HolidayManagement/OnCheckYearAvilable`, param, (result) => {
            if (result.nStatusCode === 200) {
                setDataRow({
                    ...dataRow,
                    arrRows: result.objResult.lstNewDataRow
                });

                // let dMax = new Date(moment(e).year(), 11, 31);
                // setMinYear(e);
                // setMaxYear(dMax);

                let arrResult = [];
                arrResult = dataRow.arrRows;

                arrResult.forEach(f => {
                    form.setValue(`dDatePicker_${f.sID}`, e);
                });
            }
        }, (err) => {
            DialogFn.UnBlockUI();
            if (err.nStatusCode === 409) {
                form.reset();
                form.clearErrors();

                DialogFn.Warning("ปีนี้ถูกเลือกแล้ว กรุณาเลือกปีอื่น");
            }
        });
    }

    const dataColumn: any = [
        {
            field: 'sDate',
            headerName: 'วันที่',
            headerAlign: 'center',
            minWidth: 180,
            sortable: false,
            align: "center",
            renderCell: (item) => {
                return (
                    <Grid xs={12}>
                        <FormProvider {...form}>
                            <DatePickerItem
                                name={'dDatePicker_' + item.row.sID}
                                minDate={dMinYear}
                                maxDate={dMaxYear}
                                required={true}
                                onChange={(e) => {
                                    if (e !== null) {
                                        handleDuplicateDate(e, item.row.nID)
                                    }
                                }}
                                IsShowMessageError={false}
                                view={["month", "day"]}
                                disabled={!isPermission}
                            />
                        </FormProvider>
                    </Grid>
                );
            }
        },
        {
            field: 'sHolidayName',
            headerName: 'ชื่อวันหยุด',
            headerAlign: 'center',
            align: 'center',
            minWidth: 440,
            editable: false,
            sortable: false,
            flex: 1,
            renderCell: (item) => {
                return (
                    <Grid xs={12} sx={{ width: "100%" }}>
                        <FormProvider {...form}>
                            <TextBoxItem
                                name={'sHolidayName_' + item.row.sID}
                                maxLength={250}
                                id={"sHolidayName"}
                                required={true}
                                type={'text'}
                                // onBlur={(e) => handleDuplicateName(e, item.row.nID)}
                                IsShowMessageError={false}
                                disabled={!isPermission}
                            />
                        </FormProvider>
                    </Grid>
                )
            }
        },
        {
            field: 'sDescription',
            headerName: 'รายละเอียด',
            headerAlign: 'center',
            align: 'center',
            minWidth: 440,
            editable: false,
            sortable: false,
            renderCell: (item) => {
                return (
                    <Grid xs={12} sx={{ width: "100%", pt: "1.5%" }}>
                        <FormProvider {...form}>
                            <TextAreaItem
                                name={'sDescription_' + item.row.sID}
                                maxLength={500}
                                row={1}
                                disabled={!isPermission}
                            />
                        </FormProvider>
                    </Grid>
                );
            }
        }
    ];

    useEffect(() => {
        getFormInitial();
        getTable(dataRow);
    }, []);

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container>
                    <Grid item md={3} xs={6}>
                        <DatePickerItem
                            name={`dYearPickerHoliday`}
                            id={`dYearPickerHoliday`}
                            label={"ปฏิทินประจำปี"}
                            IsYearPicker
                            minDate={moment()}
                            required={true}
                            onChange={(e) => { handleYear(e); }}
                            disabled={isEdit || !isPermission}
                        />
                    </Grid>

                    {isPermission && (
                        <Grid item md={6} xs={6} sx={{ ml: "2%" }}>
                            <BtnDuplicate id={"btnDuplicate"} onClick={form.handleSubmit((e) => { handleSubmit(e, 2) })} />
                        </Grid>
                    )}
                </Grid>

                <Grid item xs={12} sx={{ marginTop: "1.5%" }}>
                {isPermission && (
                    <Grid item sx={{ mb: "1.5%" }}>
                        <BtnAdd id={"btnDuplicate"} txt={"เพิ่มวันหยุด"} onClick={() => { handleAddItem() }} />
                    </Grid>
                      )}

                    <DataGrid
                        sTableID='HolidayManagement'
                        columns={dataColumn}
                        rows={dataRow}
                        isLoading={loadingTable}
                        onLoadData={getTable}
                        isShowCheckBox={isPermission}
                        onDelete={handleDelete}
                        isHiddenToolHead
                        isHiddenPagination
                        isSort={false}
                        isPin={false}
                        isDisableColumnMenu={true}
                    // isHiddenFooter
                    />
                </Grid>

                <Grid item xs={12} sx={{ mt: "4%" }}>
                    <Grid item xs={12} sx={{ marginTop: "4%" }}>
                        <Typography>
                            {I18n.SetText("indicatorPage.status")}
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider sx={{ mb: "2%" }} />
                        <SwitchFormItem
                            id={'statusHoliday'}
                            name={"statusHoliday"}
                            disabled={!isPermission}
                        />
                    </Grid>
                </Grid>

                {/* Button */}
                <Grid item xs={12} >
                    <Grid container spacing={2} justifyContent={"space-between"} alignItems={"start"} sx={{ display: "flex", my: "2%" }}>
                        <Grid item>
                            <BtnBack id={"addHoliday"} txt={"ย้อนกลับ"} onClick={() => { navigate("/HolidayManagement"); }} />
                        </Grid>
                        <Grid item>
                            <BtnSave id={"btnSave"} onClick={form.handleSubmit((e) => { handleSubmit(e, 1); })} IsDisabled={!isPermission} />
                            {/* <BtnSave id={"btnSave"} onClick={form.handleSubmit((e) => { handleSubmit(e, 1) })} /> */}
                        </Grid>
                    </Grid>
                </Grid>
            </FormProvider>
        </React.Fragment>
    );
}

export default HolidayManagementForm;